module.exports = __webpack_public_path__ + "static/img/newListenBtn.f4863976.png";